import { useBotbRAFContext } from "@/app/(custom-header)/botb-refer-a-friend/context";

function FriendsInvited() {
  const { rafStatus, minimumReferralsForGrantPrize, loading } = useBotbRAFContext();

  const t: any = {
    title: "Friends Invited",
  };

  return (
    <div className={"font-jost text-[#28282B] flex flex-col justify-center items-start gap-2"}>
      <div className={"text-sm font-medium leading-5 lg:text-base lg:leading-[22px]"}>{t.title}</div>
      <div className={"text-xl font-bold leading-[26px] lg:text-[32px] lg:leading-10"}>
        <span className={`${loading ? "blur-[4px] opacity-50" : ""}`}>
          {loading
            ? "0"
            : rafStatus.referredFriends > minimumReferralsForGrantPrize
              ? minimumReferralsForGrantPrize
              : rafStatus.referredFriends}
        </span>
        /{minimumReferralsForGrantPrize}
      </div>
    </div>
  );
}

export default FriendsInvited;
